import { render } from "./index.vue?vue&type=template&id=17223b52"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/messages/CookieConsent/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17223b52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17223b52', __exports__)) {
    api.reload('17223b52', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=17223b52", () => {
    api.rerender('17223b52', render)
  })

}


export default __exports__